import { render, staticRenderFns } from "./RequestExams.vue?vue&type=template&id=d9d1a24e"
import script from "./RequestExams.vue?vue&type=script&lang=js"
export * from "./RequestExams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports